import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import {Col, Row} from '@deere/ux.uxframe-react';
import DialogContent from '@material-ui/core/DialogContent';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import DialogActions from '@material-ui/core/DialogActions';
import styles from './index.css';
import GetSignNowURL from './getSignNowURL';
import {FormattedMessage} from 'react-intl';
import {roleMap, signingOptionMap} from '../../../mappers/translationMappers';


export default function SignerInfoPopup({
    showSignNowIcon,
    isHidden,
    signerInfo,
    envelopeId,
    statusColor,
    setHideSignerInfoPopup
}) {

    const handleClose = () => {
        setHideSignerInfoPopup(false);
    };

    const getDateTime = (time) => {
        return (new Date(time).toLocaleDateString() + ' '
            + new Date(time).toLocaleTimeString())
    };

    const signerStatus = {
        created: <FormattedMessage id={'labels.CREATED'}/>,
        sent: <FormattedMessage id={'labels.SENT'}/>,
        delivered: <FormattedMessage id={'labels.VIEWED'}/>,
        declined: <FormattedMessage id={'labels.DECLINED'}/>,
        completed: <FormattedMessage id={'labels.COMPLETED'}/>,
        autoresponded: <FormattedMessage id={'labels.UNDELIVERABLE'}/>
    };

    return (
        <Dialog aria-labelledby="customized-dialog-title" fullWidth={true} onClose={handleClose} open={isHidden}>
            <Row className="d-flex ml-3 mr-2 mt-2 justify-content-between">
                <span className="d-inline">
                    <h5 className="font-weight-bold mt-1">
                        <span><AccountCircleIcon className="mr-2" color="action" fontSize="large"/></span>
                        <span data-sl="mask">{signerInfo.signerName}</span>
                        <span className="font-weight-light ml-2" style={{fontSize: '13px'}}>(<FormattedMessage
                            id={'labels.ROLE'}/>: {roleMap[signerInfo.signerRole.toUpperCase()]})</span>
                    </h5>
                </span>

                <span className="d-inline">
                    <IconButton aria-label="close" onClick={handleClose} size="small">
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                </span>
            </Row>

            <Divider/>

            <DialogContent>
                <Row className={styles.dialogContentRow}>
                    <Col>
                        <dl className="uxf-dl">
                            <dt><FormattedMessage id={'labels.EMAIL'}/></dt>
                            <dd data-sl="mask">{signerInfo.signerEmail}</dd>
                            <br/>

                            <dt><FormattedMessage id={'labels.MOBILE'}/></dt>
                            <dd data-sl="mask">{signerInfo.signerContactNumber}</dd>
                            <br/>

                            <dt><FormattedMessage id={'labels.SIGNING_OPTION'}/></dt>
                            <dd>{signingOptionMap[signerInfo.signingOption.toUpperCase()]}</dd>
                            <br/>

                            <dt><FormattedMessage id={'labels.SIGNING_ORDER'}/></dt>
                            <dd>{signerInfo.signingOrder}</dd>
                        </dl>
                    </Col>

                    <Col>
                        <dl className="uxf-dl">
                            <dt><FormattedMessage id={'labels.SIGNING_STATUS'}/></dt>
                            <dd style={{color: statusColor}}>{signerStatus[signerInfo.status]}</dd>
                            <br/>

                            <dt><FormattedMessage id={'labels.SENT_DATE'}/></dt>
                            <dd>{signerInfo.envelopeSentDate
                                ? getDateTime(signerInfo.envelopeSentDate) :
                                <FormattedMessage id={'labels.NOT_AVAILABLE'}/>}</dd>
                            <br/>

                            <dt><FormattedMessage id={'labels.VIEWED_DATE'}/></dt>
                            <dd>{signerInfo.envelopeViewedDate
                                ? getDateTime(signerInfo.envelopeViewedDate) : signerInfo.deliveredDateTime ?
                                    getDateTime(signerInfo.deliveredDateTime) :
                                    <FormattedMessage id={'labels.NOT_VIEWED'}/>}</dd>
                            <br/>

                            {signerInfo.envelopeDeclinedDate ?
                                <dt><FormattedMessage id={'labels.DECLINED_DATE'}/></dt> :
                                <dt><FormattedMessage id={'labels.SIGNED_DATE'}/></dt>}
                            <dd>{signerInfo.envelopeDeclinedDate
                                ? getDateTime(signerInfo.envelopeDeclinedDate) : signerInfo.envelopeSignedDate
                                    ? getDateTime(signerInfo.envelopeSignedDate) :
                                    <FormattedMessage id={'labels.NOT_SIGNED'}/>}
                            </dd>
                            <br/>
                        </dl>
                    </Col>

                </Row>
                {signerInfo.status === 'declined' ? <Row>
                    <div className={styles.declinedDiv}>
                        <span className="d-block font-weight-bold"><FormattedMessage
                            id={'labels.DECLINED_REASON'}/></span>
                        <span className="d-block">
                            {signerInfo.envelopeDeclinedReason ? signerInfo.envelopeDeclinedReason :
                            <FormattedMessage id={'labels.NO_DECLINING_REASON_PROVIDED'}/>}
                        </span>
                    </div>
                </Row> : null}
            </DialogContent>

            <Divider/>

            <DialogActions>
                {showSignNowIcon
                    ? <Button component="a" onClick={() => GetSignNowURL(envelopeId, signerInfo)} size="small" style={{backgroundColor: '#ffde00'}} variant="outlined"><FormattedMessage id={'labels.SIGN_NOW'}/></Button>
                    : <Button disabled={true} size="small" style={{backgroundColor: '#ffde00'}} variant="outlined"><FormattedMessage id={'labels.SIGN_NOW'}/></Button>}
            </DialogActions>
        </Dialog>
    )
}
